<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kYZDCK/tc-custom/9780226376011.jpg?1722579935178" alt="This image is the cover for the book Message to Our Folks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Message to Our Folks
      </h1>
      <p class="bookDescription body article font2">
        <p>This year marks the golden anniversary of the Art Ensemble of Chicago, the flagship band of the Association for the Advancement of Creative Musicians. Formed in 1966 and flourishing until 2010, the Art Ensemble distinguished itself by its unique performance practices—members played hundreds of instruments on stage, recited poetry, performed theatrical sketches, and wore face paint, masks, lab coats, and traditional African and Asian dress. The group, which built a global audience and toured across six continents, presented their work as experimental performance art, in opposition to the jazz industry’s traditionalist aesthetics.<br/><br/> In <i>Message to Our Folks</i>, Paul Steinbeck combines musical analysis and historical inquiry to give us the definitive study of the Art Ensemble. In the book, he proposes a new theory of group improvisation that explains how the band members were able to improvise together in so many different styles while also drawing on an extensive repertoire of notated compositions. Steinbeck examines the multimedia dimensions of the Art Ensemble’s performances and the ways in which their distinctive model of social relations kept the group performing together for four decades. <i>Message to Our Folks</i> is a striking and valuable contribution to our understanding of one of the world’s premier musical groups.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Steinbeck
      </h2>
      
      <p class="authorDescription body article"><B>Paul Steinbeck</B> is assistant professor of music theory at Washington University in St. Louis. He is coauthor of <I>Exercises for the Creative Musician</I>, as well as a bassist, composer, and recording artist.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?12d87475